import React from 'react';
import { Drawer as AntdDrawer, Space } from 'antd';
import { XIcon } from '@heroicons/react/outline';

const DynamicDrawer = ({ title = '', open = false, handleClose = () => {}, children }) => {
  return (
    <AntdDrawer
      title={title}
      destroyOnClose
      onClose={handleClose}
      closable={false}
      visible={open}
      className={'SessiondetailsPanel'}
      extra={
        <Space>
          <div className='ml-3 h-7 flex items-center'>
            <button data-testid='close-button' className='bg-red rounded-circle text-gray-400 hover:text-gray-500 focus:ring-indigo-500' onClick={handleClose}>
              <XIcon className='h-6 w-6' aria-hidden='true' />
            </button>
          </div>
        </Space>
      }>
      {children}
    </AntdDrawer>
  );
};

export default DynamicDrawer;
